export const build_version = {
                    version: "20241017T111244"
                   };